import './group-nav.css';
import { h } from 'preact';

/**
 * @param {object} props
 * @param {import('../../types').Group} props.activeGroup
 * @param {boolean=} props.isCompact
 * @param {() => void} props.onBack
 * @returns
 */
export default function GroupNav({ activeGroup, isCompact = false, onBack }) {
	return (
		<nav class="group-nav-container">
			{activeGroup.level > 0 && <button onClick={onBack} className="group-nav-back-button">
				<svg viewBox="0 0 100 100">
					<path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" />
				</svg>
				{!isCompact && 'Geveloverzicht'}
			</button>}
			<div className="group-nav-group-label button">{activeGroup.label}</div>
		</nav>
	);
}
